import * as React from "react";
import * as ReactDOM from "react-dom/client";
import { AuthProvider } from "./context/AuthProvider";
import "./index.css";
import App from "./App";
import { SnackbarProvider } from 'notistack';
import { createTheme, ThemeProvider } from '@mui/material/styles';

let theme = createTheme({
  palette: {
    primary: {
      main: '#A54AFF',
    },
    secondary: {
      main: '#A54AFF',
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <ThemeProvider theme={theme}>
    <React.StrictMode>
      <SnackbarProvider preventDuplicate={false} autoHideDuration={3000}>
        <AuthProvider>
            <App />
        </AuthProvider>
      </SnackbarProvider>
    </React.StrictMode>
  </ThemeProvider>
);